import { useState } from "react";

import { PacienteFormModal } from "@/components/PacienteFormModal";
import { usePacientes } from "@/hooks/useApi";
import { useUser } from "@/hooks/useUser";

function formatCpf(cpf: string): string {
  if (cpf.length !== 11) return cpf;
  return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6, 9)}-${cpf.slice(9)}`;
}

export function PacientesPage() {
  const [q, setQ] = useState("");
  const [novo, setNovo] = useState(false);
  const [criadoMsg, setCriadoMsg] = useState<string | null>(null);
  const { data, isLoading } = usePacientes(q);
  const { data: user } = useUser();
  const podeCriar =
    user && ["admin", "farmaceutico", "enfermeira_chefe", "enfermagem"].includes(user.papel);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="font-display text-2xl font-semibold">Pacientes</h2>
        {podeCriar ? (
          <button className="btn-primary" onClick={() => setNovo(true)}>+ Novo paciente</button>
        ) : null}
      </div>
      <input
        className="input max-w-md"
        placeholder="Buscar por CPF, prontuário ou nome (mín. 3 caracteres)…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />
      {criadoMsg ? <p className="text-sm text-green-700">{criadoMsg}</p> : null}

      {q.length < 3 ? (
        <p className="text-sm text-ink-muted">Digite ao menos 3 caracteres pra buscar.</p>
      ) : isLoading ? (
        <p className="text-ink-muted">Buscando…</p>
      ) : data && data.length > 0 ? (
        <div className="card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-left text-xs uppercase tracking-wider text-ink-muted">
              <tr>
                <th className="px-4 py-3">Nome</th>
                <th className="px-4 py-3">CPF</th>
                <th className="px-4 py-3">Prontuário</th>
                <th className="px-4 py-3">Convênio</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data.map((p) => (
                <tr key={p.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2">{p.nome}</td>
                  <td className="px-4 py-2 font-mono text-xs">{formatCpf(p.cpf)}</td>
                  <td className="px-4 py-2 text-ink-muted">{p.numero_prontuario}</td>
                  <td className="px-4 py-2 text-ink-muted">{p.convenio ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-sm text-ink-muted">Nenhum paciente encontrado.</p>
      )}

      {novo ? (
        <PacienteFormModal
          onCreated={(p) => {
            setNovo(false);
            setCriadoMsg(`✅ ${p.nome} cadastrado (prontuário ${p.numero_prontuario}).`);
            setQ(p.nome.slice(0, 20));
          }}
          onClose={() => setNovo(false)}
        />
      ) : null}
    </div>
  );
}
